/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistRemixContestEndedNotificationActionData } from './ArtistRemixContestEndedNotificationActionData';
import {
    ArtistRemixContestEndedNotificationActionDataFromJSON,
    ArtistRemixContestEndedNotificationActionDataFromJSONTyped,
    ArtistRemixContestEndedNotificationActionDataToJSON,
} from './ArtistRemixContestEndedNotificationActionData';

/**
 * 
 * @export
 * @interface ArtistRemixContestEndedNotificationAction
 */
export interface ArtistRemixContestEndedNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndedNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndedNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof ArtistRemixContestEndedNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {ArtistRemixContestEndedNotificationActionData}
     * @memberof ArtistRemixContestEndedNotificationAction
     */
    data: ArtistRemixContestEndedNotificationActionData;
}

/**
 * Check if a given object implements the ArtistRemixContestEndedNotificationAction interface.
 */
export function instanceOfArtistRemixContestEndedNotificationAction(value: object): value is ArtistRemixContestEndedNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function ArtistRemixContestEndedNotificationActionFromJSON(json: any): ArtistRemixContestEndedNotificationAction {
    return ArtistRemixContestEndedNotificationActionFromJSONTyped(json, false);
}

export function ArtistRemixContestEndedNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistRemixContestEndedNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': ArtistRemixContestEndedNotificationActionDataFromJSON(json['data']),
    };
}

export function ArtistRemixContestEndedNotificationActionToJSON(value?: ArtistRemixContestEndedNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': ArtistRemixContestEndedNotificationActionDataToJSON(value.data),
    };
}

